/**
 * White Label Branding Configuration
 *
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "Hallo Taxi Stern",
  companyName: "Hallo Taxi Stern GmbH & Co.KG",

  // Contact Information
  email: "info@hallo-taxi-stern.de",
  phone: "05251 63377",
  address: "Greifswalder Str. 8a, 33106 Paderborn",
  owner: "Inderveer Takhar",
  website: "http://hallo-taxi-stern.de",

  // Supervisory Authority (Aufsichtsbehörde für Personenbeförderung)
  supervisoryAuthority: {
    name: "Kreis Paderborn",
    department: "Straßenverkehrsamt – Verkehrssicherung (Taxi- und Mietwagengenehmigungen)",
    address: "Aldegreverstraße 10-14, 33102 Paderborn",
  },

  // Data Protection Authority (Datenschutz-Aufsichtsbehörde)
  dataProtectionAuthority: {
    name: "Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)",
    address: "Kavalleriestraße 2-4, 40213 Düsseldorf",
    phone: "0211 38424-0",
    website: "https://www.ldi.nrw.de",
  },

  // Legal Information
  copyright: `© ${new Date().getFullYear()} Hallo Taxi Stern GmbH & Co.KG`,

  // Colors
  colors: {
    primary: "#FFC107", // Amber/Gold
    secondary: "#212121", // Dark Gray
    accent: "#FFD54F", // Light Amber
    success: "#388E3C", // Green
    error: "#D32F2F", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },

  // Logos and Images
  logos: {
    primary: "/assets/HalloTaxiStern_Schriftzug.png",
    icon: "/assets/HalloTaxiStern_Logo.png",
    // Hinweis: Beide Logos sind reine schwarze Typografie. Sobald für diesen
    // Mandanten die volle Landing Page (dunkle Kopfzeile/Footer) aktiviert wird,
    // hier zusätzlich `primaryOnDark` / `iconOnDark` mit weißen Varianten
    // hinterlegen — PrimaryLogoOnDark / IconLogoOnDark greifen dann automatisch.
    // Aktuell rendert App.js <LandingPage directLogin> — nur der Login-Bereich.
    favicon: "/favicon.ico",
    mobileLogo: "/assets/HalloTaxiStern_Icon.png",
  },

  // UI Elements
  ui: {
    borderRadius: "4px",
    buttonStyle: "rounded", // 'rounded', 'square', 'pill'
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },

  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },

  // Social Media
  socialMedia: {
    facebook: "",
    twitter: "",
    instagram: "",
  },
};

export default brandingConfig;
